import { render, staticRenderFns } from "./UpdateBanner.vue?vue&type=template&id=325ac15e&scoped=true"
import script from "./UpdateBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdateBanner.vue?vue&type=script&setup=true&lang=js"
import style0 from "./UpdateBanner.vue?vue&type=style&index=0&id=325ac15e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325ac15e",
  null
  
)

export default component.exports